export const friendlyDuration = (time) => {
  const arr = time.split(":");
  return `${parseInt(arr[0])}h ${parseInt(arr[1])}m`;
};
